"use client"

import { useCallback, useDeferredValue, useEffect, useState } from "react"

function matchIsElementInTheViewport(el: Element, partiallyVisible = false) {
  const { top, left, bottom, right } = el.getBoundingClientRect()
  const { innerHeight, innerWidth } = window
  return partiallyVisible
    ? ((top > 0 && top < innerHeight) || (bottom > 0 && bottom < innerHeight)) &&
        ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
    : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth
}

export const useButtonDock = () => {
  const [isVisible, setVisible] = useState(false)
  const [ref, setRef] = useState<Element | null>(null)
  // Num is a dummy state to trigger useDeferredValue to get a debounce effect
  const [num, setNum] = useState(0)
  // https://react.dev/reference/react/useDeferredValue
  const deferredValue = useDeferredValue(num)

  const onResize = useCallback(() => {
    if (ref) {
      setVisible(matchIsElementInTheViewport(ref, true))
    }
  }, [ref])

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- syncs visibility from a viewport measurement
    onResize()
  }, [deferredValue, onResize])

  const triggerDeferredValue = () => {
    setNum((num) => num + 1)
  }

  useEffect(() => {
    window.addEventListener("resize", triggerDeferredValue)
    return () => window.removeEventListener("resize", triggerDeferredValue)
  }, [onResize])

  return { ref: setRef, isVisible }
}
